/* eslint-disable max-len */
import Button from '@common_button';
import TextField from '@common_forms/TextField';
import Typography from '@common_typography';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';
import { getRewardStatistic } from '@core_modules/amrewards/services/graphql';
import Show from '@common/Show';
import Skeleton from '@common_skeleton';

const FieldPoint = ({
    onChange = () => {},
    value = '',
    placeholder = '',
    action,
    disabled = false,
    id = null,
    name = null,
    error,
    errorMessage = 'error',
    loading = false,
    toggleField = false,
    styleFrame = {},
    styleFrameText = {},
    styleTextField = {},
    usedPoints = 0,
}) => {
    const { t } = useTranslation(['common']);

    const { data: dataReward, loading: loadingReward, error: errorReward } = getRewardStatistic();
    const balance = usedPoints ? dataReward?.getRewardsStatistic?.balance - usedPoints : dataReward?.getRewardsStatistic?.balance;

    const formatPoint = (getValue) => {
        if (getValue !== undefined && getValue !== null) {
            const pointFormat = getValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return pointFormat;
        }
        return '0';
    };

    const disableButton = balance <= 0;

    return (
        <div className="w-fit flex-col border p-4 border-neutral-200 rounded-lg" id={id}>
            <div className="relative mb-2">
                <Show when={!loadingReward && !errorReward}>
                    <Typography variant="p-1">
                        Anda memiliki
                        {' '}
                        <b>{formatPoint(balance)}</b>
                        {' '}
                        poin
                    </Typography>
                </Show>
                <Show when={loadingReward}>
                    <Skeleton width="60%" height={30} />
                </Show>
            </div>
            <div className="flex flex-row items-start gap-3" style={styleFrame}>
                <TextField
                    id={`${id}Textfield`}
                    name={name}
                    styleFrameText={styleFrameText}
                    styleTextField={styleTextField}
                    disabled={!!(disabled || toggleField)}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="w-full tablet:w-[320px]"
                    absolute={false}
                    floatLabel={false}
                    hintProps={{
                        displayHintText: error,
                        hintText: errorMessage,
                        hintType: 'error',
                        className: 'max-w-[320px]',
                    }}
                />
                <Button
                    variant="outlined"
                    onClick={action}
                    disabled={disableButton}
                    className={cx(
                        'h-[40px] swift-action-apply bg-neutral-black',
                        'disabled:bg-neutral-100 disabled:!text-neutral-white',
                    )}
                    loading={loading}
                >
                    <Typography
                        color={cx(
                            'text-neutral-black group-hover:text-neutral-white',
                            disableButton ? '!text-neutral-400 group-hover:text-neutral-400' : 'text-neutral',
                        )}
                        className="uppercase leading-normal text-sm !font-bold"
                    >
                        {toggleField ? t('common:button:cancel') : t('checkout:myPoint:button')}
                    </Typography>
                </Button>
            </div>
        </div>
    );
};

export default FieldPoint;
